import { ITimelineMarker } from '@epicuro-next/ataraxia/models';
import { arrayIsEmpty, isNonNullish } from '@epicuro-next/utilities';
import { Product } from 'graphql-api/gql-api-interfaces';

import { IEpicShowMetadata } from '../interfaces/epic-show-metadata';

export function createMarkers(
  products: Map<string, Product>,
  metadata: IEpicShowMetadata,
): ITimelineMarker[] {
  if (!metadata) {
    return [];
  }

  let result: ITimelineMarker[] = Object.keys(metadata.products)
    .filter((productId) =>
      metadata.products[productId].some((product) => !product.groupId),
    )
    .reduce((acc: ITimelineMarker[], productId: string) => {
      acc.push(
        ...metadata.products[productId]
          .filter((product) => Boolean(product.start && product.end))
          .map((product) => {
            return {
              ...(product as ITimelineMarker),
              previewUrl: [products.get(productId)?.mainImageUrl as string],
              isAvailable: products.get(productId)?.isAvailable ?? true,
            };
          })
          .filter((item) => item.previewUrl.every(isNonNullish)),
      );

      return acc;
    }, []);

  result = Object.keys(metadata.groups).reduce(
    (acc: ITimelineMarker[], groupId: string) => {
      const groupMetadata = metadata.groups[groupId].metadata;

      const previewUrl = Object.keys(metadata.products)
        .filter((productId) =>
          metadata.products[productId].some(
            (product) => product.groupId === groupId,
          ),
        )
        .map((productId) => {
          return products.get(productId)?.mainImageUrl as string;
        });

      acc.push(
        ...groupMetadata
          .filter((product) => Boolean(product.start && product.end))
          .map((item) => ({
            ...(item as ITimelineMarker),
            previewUrl,
          }))
          .filter((item) => !arrayIsEmpty(item.previewUrl)),
      );
      return acc;
    },
    result,
  );

  return result;
}
